import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TextInputConfirmation } from './models/text-input-confirmation';


@Component({
  selector: 'app-text-input-confirmation-dialog',
  templateUrl: './text-input-confirmation-dialog.component.html'
})
export class TextInputConfirmationDialogComponent implements OnInit {
  model: TextInputConfirmation;

  constructor(
    public dialogRef: MatDialogRef<TextInputConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    // debugger
    this.model = {
      header: this.data.confirmation.header || 'Confirmation',
      width: this.data.confirmation.width || '60vw',
      message: this.data.confirmation.message || 'Are you sure?',
      acceptLabel: this.data.confirmation.acceptLabel || 'Continue',
      rejectLabel: this.data.confirmation.rejectLabel || 'Cancel',
      acceptDisabled: this.data.confirmation.acceptDisabled || false,
      inputPlaceholder: this.data.confirmation.inputPlaceholder || 'Enter text here',
      inputText: '',

    };
  }

  close(): void {
    this.dialogRef.close({ confirmed: false, inputText: null });
  }

  confirm(): void {
    this.dialogRef.close({ confirmed: true, inputText: this.model.inputText });
  }
}
